<!-- MOBILE -->
<div *ngIf="onExtendedMobile()" class="flex justify-content-end px-0">
	<button pButton pRipple icon="pi cm-ellipsis-v" class="p-button-text text-color"
		(click)="menu.toggle($event)"></button>
	<p-menu #menu [popup]="true" appendTo="body" [model]="menuitems"></p-menu>
</div>

<!-- DESKTOP && TABLET -->
<div *ngIf="!this.onExtendedMobile()" class="flex justify-content-end gap-1">
	<p-button id="buttonListDevice" *ngIf="!isDraftMode" pTooltip="{{ 'BACK_TO_SITES_LIST' | translate }}"
		tooltipPosition="bottom" icon="pi cm-arrow-left" size="large" (click)="toSites()" [rounded]="false" [text]="true"
		severity="secondary">
	</p-button>
	<!-- <p-button id="buttonAddDevice" [disabled]="site !== undefined && !site.CurrentlyOwned" pTooltip="{{ 'ADD_DEVICE' | translate }}"
		tooltipPosition="bottom" icon="pi cm-plus" size="large" (click)="addGateway()"
		[rounded]="false" [text]="true" severity="primary">
	</p-button> -->
	<!-- <button pButton pRipple id="buttonAddDevice" [disabled]="site !== undefined && !site.CurrentlyOwned" pTooltip="{{ 'ADD_DEVICE' | translate }}"
		tooltipPosition="bottom" icon="pi cm-plus" size="large" (click)="addGateway()"
		class="p-button-primary bg-blue-800 hover:surface-800 text-normal hover:text-primary border-transparent mb-1"
		[rounded]="false">
	</button> -->
	<p-button id="buttonEditDevice" [disabled]="site === undefined || !site.CurrentlyOwned"
		pTooltip="{{ 'EDIT_SITE' | translate }}" tooltipPosition="left" icon="pi cm-pencil" size="large"
		(click)="editSite()" [rounded]="false" [text]="true" severity="secondary">
	</p-button>
	<!--<p-button id="buttonRtcDevice" [disabled]="(site !== undefined && !site.CurrentlyOwned) || disabledRtc()"
		pTooltip="{{ 'UPDATE_RTC' | translate }}" tooltipPosition="bottom" icon="pi cm-time" size="large"
		(click)="updateRtc()" [rounded]="false" [text]="true" severity="secondary">
	</p-button>-->
	<p-button id="buttonDeleteDevice" pTooltip="{{ 'DELETE_SITE' | translate }}" tooltipPosition="left" [disabled]="site === undefined || !site.CurrentlyOwned"
		icon="pi cm-trash" size="large" (click)="deleteSite()" [rounded]="false" [text]="true" severity="danger">
	</p-button>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>